import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedNewPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbToastModule,
    SharedNewPipesModule,
    SharedComponentsModule,
    SharedDirectivesModule,
  ],
  exports: [SharedNewPipesModule, SharedComponentsModule, SharedDirectivesModule],
})
export class SharedNewModule {}
